<!-- <mat-dialog-content> -->
<div class="chatbot-dialog-root">
  <div class="insight-container">
  <div class="insight-title" style="position: sticky; top: 0;">
      <div class="title">All Chats</div>
      <div class="insight-title-icon-group">
        <span class="insight-title-icon" (click)="toggleMinimize()" style="cursor:pointer; margin-bottom: 6px !important;">
          <mat-icon  *ngIf="!minimized" fontIcon="minimize">minimize</mat-icon>
          <mat-icon *ngIf="minimized" fontIcon="fullscreen" style="padding-bottom: 4px !important;">fullscreen</mat-icon>
        </span>
        <span class="insight-title-icon" mat-dialog-close (click)="closeDialog()">
          <mat-icon fontIcon="close">close</mat-icon>
        </span>
      </div>
    </div>

  <div class="insight-content" *ngIf="!minimized">
    <div class="insight-text" style="margin-top: 10px;">
      <div class="ai-image">
        <img src="magic_ai.png" />
        <!-- <img src="Sense AI Icon Animated.png" /> -->
      </div>
    </div>
    <div class="ai-caption">What do you want to do today?</div>
    <div class="sub-heading">
      The information provided by Chatbot may contain inaccuracies, so be sure
      to carefully verify answers.
    </div>
    <!-- <div class="sub-heading1">Generate document summary</div>
      <div class="sub-heading1">AI analysis and insights</div>
      <div class="sub-heading1">Report generation</div> -->
    <ng-container *ngFor="let message of messages">
      <div
        class="chat-message chatbot-answer-markdown"
        [ngClass]="{
          bot: message.author === 'bot',
          user: message.author === 'user'
        }"
      >
        <div *ngIf="message.author === 'bot'">
          <markdown class="message-content chatbot-answer-markdown">{{ message.content }}</markdown>
        </div>
        <span *ngIf="message.author === 'user'" class="message-right">{{ message.content }}</span>
      </div>
      <div
        *ngFor="let msg of message.msgData; let i = index"
        
      >
        <div class="doc-header" style="display: flex; align-items: center;">
          <span
            class="chat-message"
            style="cursor: pointer; flex: 1; display: flex; align-items: center; gap: 8px;"
            *ngIf="msg.doc_category !== ''"
            [ngClass]="{ bot: message.author === 'bot', user: message.author === 'user' }"
            (click)="openDocument(msg)"
          >
            <ng-container *ngIf="msg.original_filename.endsWith('.pdf'); else excelIcon">
              <mat-icon class="pdf-file-icon" [title]="getPageNumber(msg)">picture_as_pdf</mat-icon>
            </ng-container>
            <ng-template #excelIcon>
              <mat-icon class="excel-file-icon" style="color: green;" [title]="getPageNumber(msg)">description</mat-icon>
            </ng-template>
            <span class="filename-text">{{ msg.original_filename }}</span>
          </span>

        </div>
          <button class="chunk-text" (click)="toggleDocExpand(msg)">
            {{ msg.expanded ? 'Hide Sources' : 'Show Sources' }}
          </button>
        <div *ngIf="msg.expanded && msg.chunks && msg.chunks.length > 0" class="doc-chunks" style="margin-left: 32px;">
          <div *ngFor="let chunk of msg.chunks; let ci = index" style="margin-bottom: 8px;">
            <div style="display: flex; align-items: center;">
              <button (click)="toggleChunkExpand(chunk)" 
              class="doc-category" style="margin-right: 4px;"
              >
                {{ chunk.expanded ? '-' : '+' }}
              </button>
              <span class="doc-category">{{ msg.doc_category }}</span>
              <span class="doc-category" style="text-wrap: nowrap;margin-left: 4px;">Page {{ chunk.page_number }}</span>
            </div>
            <div *ngIf="chunk.expanded" class="chatbot-answer-markdown" style="background: white; border: 1px solid #d1d5db; padding: 10px 14px; border-radius: 4px; margin-top: 2px; margin-right: 15px !important; margin-left: 0px;margin-bottom: 0px !important; margin-top: 4px;">
              <markdown>{{ chunk.text }}</markdown>
            </div>
          </div>
        </div>
      </div>

      <div class="my message" *ngIf="message.showWaiting">
        <span class="jumping-dots">
          <span class="dot-1"></span>
          <span class="dot-2"></span>
          <span class="dot-3"></span>
        </span>
      </div>
      <div class="error-text" *ngIf="message.errorMessage">
        {{ message.errorText }}
      </div>
    </ng-container>
    <div class="msg-body" style="position: sticky; bottom: 0;padding-bottom: 8px;">
      <input
        class="message-text"
        [(ngModel)]="value"
        (keyup.enter)="sendMessage()"
        type="text"
        placeholder="message"
      />
      <button class="message-button" (click)="sendMessage()" mat-icon-button>
        <mat-icon>send</mat-icon>
      </button>
    </div>
  </div>
</div>
<!-- </mat-dialog-content> -->
